<template>
    <div class="discountScan">
        <!-- <topNav :title="title"></topNav> -->
        <div class="coupon-type" v-show="!pageType && !disabledGet">
            <h2>请选择相应车辆</h2>
            <div class="tab" @click="pageType=1">
                <span>无牌车（扫码入场）</span><b></b>
            </div>
            <div class="tab" @click="pageType=2">
                <span>有牌车（识别入场）</span><b></b>
            </div>
        </div>
        <div class="discountScan-box" v-show="pageType && !disabledGet">
            <div id="topnav">
                <div class="van-hairline--bottom topnav van-nav-bar" style="z-index: 1;">
                    <div class="van-nav-bar__left" @click="onClickLeft"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i></div>
                    <div class="van-ellipsis van-nav-bar__title" style="color:#666">优惠券领取</div>
                </div>
            </div>
            <div class="coupon-container">
                <div class="coupon-left">
                    <p>{{couponType}}</p>
                </div>
                <div class="coupon-right">
                    <p class="type-msg">优惠券类型：{{couponType}}</p>
                    <p class="msg">优惠值</p>
                    <p class="coupon-detail">
                        <span>{{couponValue}}
                            <i v-show="couponTypeCode == 0">小时</i>
                            <i v-show="couponTypeCode == 1">元</i>
                            <i v-show="couponTypeCode == 2">折</i>
                        </span>
                        <b>有效期: {{couponValidhours}}小时</b>
                    </p>
                </div>
            </div>
            
            <commonInput v-show="pageType == 2" @commitCarNum="getDiscount" @carNumChange="carNumChange" :btntxt="'领取优惠券'">
                <div v-if="hostname!='spps.ncgzzh.com'" class="queryfee_btn" slot="btn" @click.stop="autoQueryFee(inputCarNum)" >前往缴费</div>
            </commonInput>
            <div v-show="pageType == 1" class="get-coupon-btn" @click="getDiscount('')">领取优惠券</div>
        </div>
        <div class="error-msg" v-show="disabledGet">{{msg}}</div>
    </div>
</template>
<script>
import topNav from "@/components/topnav/topnav"
import {DETAIL as API} from "@/assets/api";
import {Toast,Dialog} from 'vant';
import commonInput from "@/components/common/commonInput"
import md5 from 'js-md5';
export default {
    name: 'discountScan',
    components:{
        topNav,
        commonInput
    },
    data() {
        return {
            title:"优惠券领取",
            disabledAjax:false,//禁止请求ajax请求
            couponValue:"",//优惠券券值
            couponValidhours:"",//优惠券有效期
            couponType:"",//优惠券类型
            bsType:"",//浏览器类型
            showBtn:false,//显示无牌车勾选按钮
            btnActive:false,//是否勾选
            couponTypeCode:"",
            disabledGet:false,//是否可以领取
            pageType:0,//0 默认 1 无牌车 2有牌车
            msg:"请使用微信或支付宝扫码领取",//
            loadinginstace:null,

            inputCarNum: ''

        }
    },
    computed: {
        hostname() {
        return window.location.hostname;
        }
    },
    created(){
        if(this.commonUtil.isWXRedirectBack()) {
            this.disabledGet = true;
            return
        }
        if(!this.validUrlIsValid()) return
        
        this.bsType = this.commonUtil.browserType()
        if(this.bsType != "wx" && this.bsType !="al"){
            this.disabledGet = true;
            this.msg = "请使用微信或支付宝扫码领取";
            return
        }

        this.validIsOutOfTime()
 
    },
    mounted(){
        this.couponValue = sessionStorage.getItem("coupon_value");
        this.couponValidhours = sessionStorage.getItem("coupon_validhours");
        this.couponTypeCode = sessionStorage.getItem("coupon_type");
        this.couponType = this.getCouponType(sessionStorage.getItem("coupon_type"));
        if(this.bsType == "wx" || this.bsType == "al"){
            this.showBtn = true;
        }else{
            this.showBtn = false;
        }
    },
    methods:{
        validUrlIsValid(){
            let mac = this.$route.query.mac
            let start_time = this.$route.query.start_time
            let queryStr = location.href.split('?')[1] || ''
            queryStr = decodeURI(queryStr)
            if (start_time) {
                queryStr = queryStr.replace('&mac=' + mac, '').replace('&start_time=' + start_time, '')
            } else {
                queryStr = queryStr.replace('&mac=' + mac, '')
            }
            let encStr = queryStr +'&key=02468ACE13579BDF'
            let signStr = md5(encStr).toUpperCase().substring(0, 8)
            if(signStr !== mac){
                this.disabledGet = true;
                this.msg = "非法二维码";
            }
            return signStr == mac
        },
        validIsOutOfTime(){
            // 固定码带过期时间,动态码默认5分钟过期
            let expire_time = sessionStorage.getItem("expire_time");
            //二维码生效时间
            let start_time = sessionStorage.getItem("start_time");
            if (start_time) {
                if (new Date().getTime() < start_time * 1000) {
                    this.disabledGet = true;
                    this.msg = "二维码未生效";
                    return
                }
            }
            if (expire_time) {
                if (expire_time * 1000 < new Date().getTime()) {
                    this.disabledGet = true;
                    this.msg = "二维码已过期";
                }
            } else {
                let generatedTime = sessionStorage.getItem("generated_time");
                if (generatedTime) {
                    generatedTime = parseInt(generatedTime) * 1000;//创建时间 毫秒
                    generatedTime = generatedTime + 1000 * 60 * 5;//加上5分钟即为过期时间
                    if (generatedTime < new Date().getTime()) {
                        this.disabledGet = true;
                        this.msg = "二维码已过期";
                    }
                }
            }
        },
        carNumChange(carNum){
            this.inputCarNum = carNum
        },
        autoQueryFee(carNum){
            if(carNum && !(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[警京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{0,1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}[A-Z0-9]{0,1}[A-Z0-9]{0,1}$/.test(carNum))){
                //不是车牌
                this.$toast({
                    duration:1200,
                    message: '车牌号格式不正确'
                });
                return;
            }
            this.$router.push({
                name: 'index',
                query: {
                    carNum: carNum,
                    autoQueryFee: 1
                }
            })
        },
        getDiscount(carNum){//领取优惠券
            
            this.loadinginstace = this.$toast.loading({
                mask: true,
                message: '领取中...',
                duration:0
            });
            let id = sessionStorage.getItem("id");
            let mode = sessionStorage.getItem("mode");
            let coupon_type = sessionStorage.getItem("coupon_type");
            let coupon_value = sessionStorage.getItem("coupon_value");
            let coupon_validhours = sessionStorage.getItem("coupon_validhours");
            let originalId = sessionStorage.getItem("originalId");
            let phonenumber = sessionStorage.getItem("phonenumber");
            let generated_time = sessionStorage.getItem("generated_time");
            let expire_time = sessionStorage.getItem("expire_time");
            
            let req={
                id,
                mode,
                coupon_type,
                coupon_value,
                coupon_validhours,
                originalId,
                phonenumber
            }
            if(generated_time) req.generated_time = generated_time
            if(expire_time) req.expire_time = expire_time
            if(carNum) req.vehicleno = carNum

            this.$http({
                method: 'post',
                url: API.GET_DISCOUNT_COUPON,
                data: this.qs.stringify(req),
                success: function(data){
                    if(this.loadinginstace){
                        this.loadinginstace.clear();
                    }
                    if(data.code == 0){
                        
                        this.$toast({
                            duration:1200,
                            type: 'success',
                            message: '优惠券领取成功'
                        })
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: data.msg
                        })
                    }
                }.bind(this),
                error: function(data){
                    this.$dialog.alert({
                        title: '提示',
                        message: data.msg
                    })
                }
            })
        },
        getCouponType(type){//
            let str ="";
            if(type == "0"){
                str = "时间券";
            }else if(type == "1"){
                str = "金额券";
            }else if(type == "2"){
                str = "折扣券";
            }
            return str;
        },
        onClickLeft(){//导航栏上的返回按钮
            this.pageType = 0;
        }
    },
    watch:{
        "$route":{
            handler(value,oldValue){
                let originalId = sessionStorage.getItem("originalId");
                if(!originalId || this.commonUtil.getUrlKey("originalId")){
                    return;
                }
                
            },
            immediate:true
        },
        btnActive(value){
            if(value){
                this.$dialog.alert({
                    title: '提示',
                    message: '无牌车辆领取的优惠券，仅支持当前客户端，当前账号使用。'
                })
            }
        }
    }


}
</script>
<style lang="less" scoped>
.discountScan{
    .coupon-type{
        h2{
            color: #666;
            font-size: 13px;
            text-align: left;
            text-indent: 20px;
            line-height: 50px;
        }
        .tab{
            width: 80%;
            height: 119px;
            background: url("../../static/images/card_bg.png") no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            line-height: 107px;
            color: #fff;
            font-size: 18px;
            text-indent: 30px;
            text-align: left;
            margin-top: 6px;
            &:last-child{
                background: url("../../static/images/nocard_bg.png") no-repeat;
                background-size: 100% 100%;
            }
            b{
                float: right;
                margin-top: 44px;
                margin-right: 24px;
                height: 18px;
                width: 9px;
                background: url("../../static/images/icon_back.png") no-repeat;
                background-size: 100% 100%;
            }
            p{
                color: #fff;
                font-size: 18px;
            }
        }
    }
    .error-msg{
        color: #999;
        line-height: 100px;
        text-align: center;
    }
    .coupon-container{
        height: 81px;
        width: 75%;
        margin: 0 auto;
        margin-top: 20px;
        .coupon-left{
            float: left;
            width: 14%;
            background: url("../../static/images/coupon-left.png") no-repeat;
            background-size: 100% 100%;
            height: 81px;
            color: #fff;
            p{
                font-size: 12px;
                text-align: center;
                width: 10px;
                line-height: 15px;
                margin: 0 auto;
                margin-top: 18px;
            }
        }
        .coupon-right{
            float: right;
            width: 85%;
            background: url("../../static/images/coupon-right.png") no-repeat;
            background-size: 100% 100%;
            height: 81px;
            color: #999;

            font-size: 10px;
            line-height: 24px;
            text-indent: 15px;
            text-align: left;
            .type-msg{
                font-size: 10px;
                line-height: 24px;
                text-indent: 15px;
                text-align: left;
            }
            .msg{
                font-size: 10px;
                line-height: 23px;
                text-indent: 15px;
                text-align: left;
            }
            .coupon-detail{
                font-size: 10px;
                margin-top: 5px;
                height: 24px;
                text-align: left;
                text-indent: 15px;
                span{
                    font-size: 24px;
                    color: rgb(70,135,248);
                    i{
                        font-size: 15px;
                        font-style: normal;
                    }
                }
                b{
                    float: right;
                    margin-top: 10px;
                }
            }
        }
    }
    .list-container{
        padding-top: 20px;
        ul{
            padding-bottom: 30px;
        }
        li{
            height: 68px;
            border-radius: 5px;
            position: relative;
            img{
                float: left;
                height: 42px;
                width: 42px;
                margin-left: 17px;
                margin-top: 14px;
            }
        }
        .right-content{
            top: 9px;
            right: 7px;
            left: 64px;
            position: absolute;
            padding-left: 5px;
            p{
                width: 100%;
                line-height: 17px;
                font-size: 12px;
                color: #999;
                text-align: left;
                span{
                    right: 5px;
                    position: absolute;
                    float: right;
                    &.blue{
                        color:#4687f8;
                    }
                }
                b{
                    right: 0;
                    position: absolute;
                    border: 1px solid #e5e5e5;
                    border-radius: 10px;
                    width: 52px;
                    text-align: center;
                    color: rgba(220,20,60,0.5);
                    font-size: 12px;
                    height: 18px;
                    &.pass{
                        color: rgba(30,144,255,0.5);
                    }
                }
            }
        }
    }
    .myCheckBox{
        color:#666;
        font-size: 12px;
        height: 15px;
        line-height: 15px;
        text-align: left;
        padding-left: 17px;
        b{
            float: left;
            width: 15px;
            height: 15px;
            margin-right: 5px;
            border-radius: 100%;
            background: url("../../static/images/rb.png") no-repeat;
            background-size: 15px;
            &.active{
                background: url("../../static/images/rb_s.png") no-repeat;
                background-size: 15px;
            }
        }
    }
}
.get-coupon-btn{
    width: 92%;
    text-align: center;
    height: 2.4rem;
    line-height: 2.4rem;
    background-color: rgb(70,135,248);
    color: white;
    margin: 1.2rem auto;
    border-radius: 3px;
    font-size: 0.9rem;
}
.discountScan-box{
    .van-nav-bar{
        line-height: 2.4rem;
    }
}
.queryfee_btn{
    width: 92%;
    text-align: center;
    height: 2.4rem;
    line-height: 2.4rem;
    background-color: #07c160;
    color: white;
    margin: 1.2rem auto;
    border-radius: 3px;
    font-size: 0.9rem;
}
</style>




// WEBPACK FOOTER //
// src/components/discountScan.vue